"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  button {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  z-index: ", ";\n  border-radius: ", "px;\n  color: ", ";\n  width: 100%;\n  background-color: ", ";\n\n  ", " {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NotificationItem = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.zIndex.snackbar;
}, function (props) {
  return props.theme.shape.borderRadius;
}, function (props) {
  if (props.variant === 'success') {
    return props.theme.palette.success.mainText;
  } else if (props.variant === 'error') {
    return props.theme.palette.error.mainText;
  } else if (props.variant === 'alert') {
    return props.theme.palette.orange.darkText;
  } else {
    return props.theme.palette.primary.darkText;
  }
}, function (props) {
  if (props.variant === 'success') {
    return props.theme.palette.success.main;
  } else if (props.variant === 'error') {
    return props.theme.palette.error.main;
  } else if (props.variant === 'alert') {
    return props.theme.palette.orange.dark;
  } else {
    return props.theme.palette.primary.dark;
  }
}, function (props) {
  return props.theme.breakpoints.up('sm');
}, function (props) {
  return props.fullWidth ? 'width: 100%;' : 'max-width: 640px; min-width: 400px;';
});

NotificationItem.Button = _styledComponents["default"].div(_templateObject2());

var NotificationBarItem =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(NotificationBarItem, _PureComponent);

  function NotificationBarItem() {
    (0, _classCallCheck2["default"])(this, NotificationBarItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(NotificationBarItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(NotificationBarItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          variant = _this$props.variant,
          message = _this$props.message,
          button = _this$props.button,
          onClose = _this$props.onClose,
          fullWidth = _this$props.fullWidth;
      return _react["default"].createElement(_Fade["default"], {
        "in": true,
        timeout: {
          enter: 1800,
          exit: 2000
        }
      }, _react["default"].createElement("div", {
        className: "mb-2 mx-2 mx-sm-3 mb-sm-3"
      }, _react["default"].createElement(NotificationItem, {
        variant: variant,
        fullWidth: fullWidth,
        className: "row pl-3 pr-2 pr-sm-3 pt-2 pb-2 align-items-center mb-2 mt-2 no-gutters"
      }, icon && _react["default"].createElement("div", {
        className: "col-sm-auto pr-sm-3 pr-0 col"
      }, (0, _isString["default"])(icon) && _react["default"].createElement(_Icon["default"], {
        className: "d-flex",
        icon: "check"
      }), !(0, _isString["default"])(icon) && icon), _react["default"].createElement("div", {
        className: "col-sm col-12 order-1 pr-4"
      }, message), button && _react["default"].createElement(NotificationItem.Button, {
        className: "col-sm-auto col-12 order-2 mt-sm-0 mt-3 pr-sm-0 pr-2 pb-1 pb-sm-0"
      }, button), _react["default"].createElement("div", {
        className: "col-auto order-sm-4 order-0 pl-sm-3 pl-0"
      }, _react["default"].createElement(_Button["default"], {
        color: "transparent",
        variant: "text",
        onClick: onClose,
        "aria-label": "Close"
      }, _react["default"].createElement(_Icon["default"], {
        className: "d-flex",
        icon: "close"
      }))))));
    }
  }]);
  return NotificationBarItem;
}(_react.PureComponent);

NotificationBarItem.propTypes = {
  icon: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].node]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  variant: _propTypes["default"].oneOf(['default', 'alert', 'error', 'success']),
  fullWidth: _propTypes["default"].bool,
  button: _propTypes["default"].node,
  onClose: _propTypes["default"].func
};
NotificationBarItem.defaultProps = {
  variant: 'default'
};
var _default = NotificationBarItem;
exports["default"] = _default;